var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimeback = function SvgTimeback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 32,
    fill: "none",
    viewBox: "0 0 31 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#timeback_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#510C76",
    d: "M13.15 32c7.262 0 13.15-5.887 13.15-13.15 0-7.262-5.888-13.15-13.15-13.15S0 11.589 0 18.85C0 26.113 5.887 32 13.15 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#19D3C5",
    d: "M16.665 30.474c7.263 0 13.15-5.887 13.15-13.15 0-7.262-5.887-13.15-13.15-13.15-7.262 0-13.15 5.888-13.15 13.15s5.888 13.15 13.15 13.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#510C76",
    d: "M23.551 29.716a1.184 1.184 0 0 1-.62-2.194 11.9 11.9 0 0 0 5.7-10.198c0-6.596-5.369-11.965-11.965-11.965a1.185 1.185 0 0 1 0-2.369C24.57 2.99 31 9.42 31 17.325c0 5.018-2.554 9.581-6.828 12.216a1.2 1.2 0 0 1-.62.175Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#510C76",
    d: "M17.111 8.264c-.393 0-.772-.194-1-.55l-2.122-3.33a1.18 1.18 0 0 1 .184-1.498l2.72-2.564a1.183 1.183 0 1 1 1.626 1.72l-2.005 1.896 1.597 2.502c.35.55.19 1.284-.36 1.635a1.16 1.16 0 0 1-.635.184zm4.601 14.548c-.265 0-.53-.09-.749-.266l-5.042-4.127a1.2 1.2 0 0 1-.436-.92v-5.941a1.185 1.185 0 0 1 2.37 0v5.383l4.606 3.772c.507.412.582 1.16.165 1.668a1.19 1.19 0 0 1-.919.436z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "timeback_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h31v32H0z"
  })))));
};
export default SvgTimeback;